import { Component, Output, EventEmitter, Input } from "@angular/core";

import { Validateable } from "@models";
import { NewAccount } from "@modules/new_account/domain/entities/new_account.model";

// TODO: eslint fix
/* eslint-disable @typescript-eslint/no-explicit-any */
@Component({
	selector: "bp-switch",
	templateUrl: "./bp-switch.component.html",
	styleUrls: ["./bp-switch.component.scss"],
	standalone: false
})
export class BpSwitchComponent {
	@Input()
	public mb = 15;

	@Input()
	public css = "";

	@Input()
	public error: string = null;

	@Input()
	public disabled: boolean = false;

	@Output()
	public modelChange: EventEmitter<any> = new EventEmitter<any>();
	/**
	 * The Validateable Object holding the field you want to bind to this input
	 */
	@Input()
	public model: Validateable | NewAccount = new Validateable();

	@Input()
	public hasSwitchTooltip: string = "";

	public get wiggle(): boolean {
		if (!this.model || !this.field || !this.model.hasOwnProperty(this.field + "_wiggle")) {
			return false;
		}

		return this.model[this.field + "_wiggle"];
	}

	public get value(): any {
		if (!this.model || !this.field) {
			return "";
		}
		return this.model[this.field];
	}

	public set value(newVal: any) {
		this.model[this.field] = newVal;
	}

	public __value: boolean;

	@Input("value")
	public get _value(): boolean {
		if (this.field) {
			return this.value;
		}
		return this.__value;
	}

	public set _value(val: boolean) {
		if (this.field) {
			this.value = val;
		} else {
			this.__value = val;
		}
		this.valueChange.emit(val);
	}

	public updateValue(newValue: boolean): void {
		this._value = newValue;
	}

	@Output()
	public valueChange: EventEmitter<boolean> = new EventEmitter<boolean>();

	/**
	 * The name of the field on the model object you want to bind this input to
	 */
	@Input()
	public field: string;

	public onClick(): void {
		if (this.disabled) {
			return;
		}
		this._value = !this._value;
		this.modelChange.emit(this._value);
	}
}
